import Button from '@/components/Buttons/Button';
import { HttpStatus } from '@/errors/http-status';
import CodeIconBlack from '@/images/Code.svg';
import CodeIconWhite from '@/images/CodeWhite.svg';
import { AgentShareModal, EmbedAgentModal } from '@/pages/agents/components/modals';
import { defaultErrorHandler } from '@/utils/default-error-handler';
import { IAgent } from '@d-id/types';
import styled from '@emotion/styled';
import { useState } from 'react';

const StyledButton = styled(Button)<{ isSecondary?: boolean }>`
    background-color: ${({ theme, isSecondary }) => isSecondary && theme.colors.white};
    color: ${({ theme, isSecondary }) => isSecondary && theme.colors.black[800]};
    border-color: ${({ theme, isSecondary }) => isSecondary && theme.colors.black[300]};

    :hover {
        border-color: ${({ theme, isSecondary }) => isSecondary && theme.colors.black[300]} !important;
    }
`;

interface Props {
    agent?: IAgent;
}

export const AgentEmbedButton = ({ agent }: Props) => {
    const [isEmbedded, setIsEmbedded] = useState(!!agent?.embed || false);
    const [isShareModalOpen, setShareModalState] = useState(false);
    const [isEmbedModalOpen, setEmbedModalState] = useState(false);

    return (
        <>
            {agent && (
                <StyledButton
                    isSecondary={isEmbedded}
                    color="secondary"
                    background-color="secondary"
                    border-color="secondary"
                    variant={isEmbedded ? 'outlined' : 'contained'}
                    startIcon={<img src={isEmbedded ? CodeIconBlack : CodeIconWhite} />}
                    onClick={() => setShareModalState(true)}>
                    {isEmbedded ? 'Manage embed' : 'Embed'}
                </StyledButton>
            )}
            <AgentShareModal
                agent={agent}
                open={isShareModalOpen}
                onClose={() => {
                    setShareModalState(false);
                    setIsEmbedded(true);
                }}
                errorHandler={async error => {
                    if (error?.response?.status === HttpStatus.MAX_EMBED_AGENTS_LIMIT_REACHED) {
                        console.warn('Max embed agents limit reached');
                        setEmbedModalState(true);
                        setShareModalState(false);
                    } else {
                        defaultErrorHandler(error);
                    }
                }}
            />
            <EmbedAgentModal isOpen={isEmbedModalOpen} onClose={() => setEmbedModalState(false)} isMoreAgents={agent?.embed} />
        </>
    );
};
